import _u from './util';

/* Share link basic functions */
function fburl() {
    _u.wmdPageLink('mse-share_face');
    var fbtitle = document.title;
    var fblink = window.location.protocol + '//' + window.location.host + window.location.pathname + '?src=mse_fb_share';
    var fbsharelink = "//www.facebook.com/share.php?u=" + encodeURIComponent(fblink) + "&t=" + fbtitle;
    window.open(fbsharelink);
}
function twiturl() {
    _u.wmdPageLink('mse-share_twit');
    var twtitle = document.title;
	var twiturl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?src=mse_tw_share';
    var ftwiturl = "//twitter.com/share?url=" + encodeURIComponent(twiturl) + "&text=" + encodeURIComponent(twtitle) + "&via=medscape";
    window.open(ftwiturl);
}
function linkedinurl() {
    _u.wmdPageLink('mse-share_link');
    var title = document.title;
	var url = window.location.protocol + '//' + window.location.host + window.location.pathname + '?src=mse_lk_share';
    var fturl = "//www.linkedin.com/cws/share?url=" + encodeURIComponent(url) + "&title=" + title
    window.open(fturl);
}

function emailInit() {
		
	if (_u.qS('.slry-share-icon.email') != null) {		
		function loadSendMsg() {
			_u.wmdPageLink('mse-share_email');
			if (typeof sendMsgInit == 'undefined') {
				var sendMsgJs = document.createElement('script');
				sendMsgJs.onload = function() {		
						sendMsgInit();
				};
				document.body.appendChild(sendMsgJs);
				sendMsgJs.src = 'https://img.' + getDomain() + 'medscapestatic.com/medscape-core/common/js/send-msg/send-msg.js';
			} else {
				sendMsgInit();
			}
		}		
		_u.qS('.slry-share-icon.email').forEach(function(elem) {
			elem.addEventListener('click', loadSendMsg);
		});
	}
	
	_u.qS('.slry-share-icon.fb').forEach(function(elem) {
		elem.addEventListener('click', fburl);
	});
	_u.qS('.slry-share-icon.twitter').forEach(function(elem) {
		elem.addEventListener('click', twiturl);
	});
	_u.qS('.slry-share-icon.li').forEach(function(elem) {
		elem.addEventListener('click', linkedinurl);
	});
	
}

export default emailInit;